<div class="close-button"
	role="button"
	[tabindex]="tabIndex"
	[id]="linkId"
	[attr.aria-label]="'common.ui.close' | translate"
	(keyup.enter)="pressCloseButton($event)"
	(click)="clickCloseButton($event)">
	<div class="x" aria-hidden="true">x</div>
</div>
